import React, { Component, useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Styles } from "./styles/aboutUs.js";
import service from '../services/service';
import { useTranslation } from 'react-i18next'
import cookies from 'js-cookie'
import DSC_5578 from "../assets/images/DSC_5578.jpg"
import DSC_5595 from "../assets/images/DSC_5595.jpg";
import UserService from '../services/UserService';
import "./AboutUsNew.css";

const languages = [

    {
        code: 'en',
        name: 'English',
        country_code: 'gb',
    },
]
function AboutUsNew() {

    useEffect(() => {
        UserService.generateToken();
    }, []);


    const currentLanguageCode = cookies.get('i18next') || 'en'
    const currentLanguage = languages.find((l) => l.code === currentLanguageCode)
    const { t } = useTranslation()
    useEffect(() => {
        document.body.dir = currentLanguage.dir || 'ltr'
        document.title = t('app_title')
    }, [currentLanguage, t])
    const [getAboutState, setAboutState] = useState({
        isOpen: false,
        coursesCount: 0,
        learnerCount: 0,
        instructorCount: 0
    });

    function openModal() {
        setAboutState({ isOpen: true })
    }

    return (
        <Styles>
            <Container>
                {/* About Us */}
            <section className="about-us">
                <Container>
                    <div className="about-content">
                        <h4 className="about-title">{t("title")}</h4>
                    </div>
                    <br />
                    <Row>
                        <Col md="6">
                            <div className="about-image">
                                <img src={DSC_5578} className="main-img" alt="" />
                                <img src={process.env.PUBLIC_URL + "/assets/images/pattern.png"} className="pattern-img" alt="" />
                                <div className="video-player" style={{ backgroundImage: `url(${DSC_5595})` }}>
                                </div>
                            </div>
                        </Col>
                        <Col md="6">
                            <div className="about-content">
                                <p className="about-para" style={{ textAlign: "justify" }}>{t("about_desc1")}</p>
                            </div>
                        </Col>
                    </Row>
                    <br /><br />
                    <Row>
                        <div className="about-content">
                            <p className="about-para" style={{ textAlign: "justify" }}>{t("about_desc2")}</p>
                            <p className="about-para" style={{ textAlign: "justify" }}>{t("about_desc3")}</p>
                        </div>
                    </Row>
                </Container>
            </section>
            </Container>
        </Styles>
    )
}

export default AboutUsNew
